module.exports = __webpack_public_path__ + "img/Ladder.a0612fc4.png";